import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// app
import { AdminPageComponent } from './pages/admin/admin-page.component'
import { ArchiveCreateComponent } from './parts/admin/archive/create/archive-create.component'
import { ArchiveEditComponent } from './parts/admin/archive/edit/archive-edit.component'
import { AdminLiveIndexComponent } from './parts/admin/live/index/live-index.component'
import { LiveCreateComponent } from './parts/admin/live/create/live-create.component'
import { LiveEditComponent } from './parts/admin/live/edit/live-edit.component'
import { AdminLiveIndexDetailComponent } from './parts/admin/live/index-detail/live-index-detail.component'
import { CreatorIndexComponent } from './parts/admin/creator/creator-index/creator-index.component'
import { DashboardIndexComponent } from './parts/admin/dashboard/index/dashboard-index.component'
import { SuspendUserComponent } from './parts/admin/suspend-user/suspend-user.component'
import { SuspendMagazineComponent } from './parts/admin/suspend-magazine/suspend-magazine.component'
import { ProfileRemoveComponent } from './parts/admin/profile-remove/profile-remove.component'
import { CommentDeleteComponent } from './parts/admin/comment-delete/comment-delete.component'
import { NgWordComponent } from './parts/admin/ng-word/ng-word.component'
import { FollowerCountComponent } from './parts/admin/follower-count/follower-count.component'
import { MaintenanceShowComponent } from './parts/admin/maintenance/maintenance-show/maintenance-show.component'
import { MaintenanceCreateComponent } from './parts/admin/maintenance/maintenance-create/maintenance-create.component'
import { ConfigShowComponent } from './parts/admin/config/config-show/config-show.component'
import { ConfigCreateComponent } from './parts/admin/config/config-create/config-create.component'
import { AdminGiftIndexComponent } from './parts/admin/gift/index/gift-index.component'
import { AdminGiftCreateComponent } from './parts/admin/gift/create/gift-create.component'
import { AdminGiftEditComponent } from './parts/admin/gift/edit/gift-edit.component'
import { AdminPointPlanIndexComponent } from './parts/admin/point-plan/index/point-plan-index.component'
import { AdminPointPlanCreateComponent } from './parts/admin/point-plan/create/point-plan-create.component'
import { AdminPointPlanEditComponent } from './parts/admin/point-plan/edit/point-plan-edit.component'
import { TransferIndexComponent } from './parts/admin/transfer/transfer-index/transfer-index.component'
import { AdminPointBalanceIndexComponent } from './parts/admin/point-balance/index/point-balance-index.component'
import { AdminPointHistoryIndexComponent } from './parts/admin/point-history/index/point-history-index.component'
import { AdminOrderHistoryIndexComponent } from './parts/admin/order-history/index/order-history-index.component'
import { AdminSalesHistoryIndexComponent } from './parts/admin/sales-history/index/sales-history-index.component'

const routes: Routes = [
  {
    path: 'admin',
    component: AdminPageComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardIndexComponent,
      },
      {
        path: 'suspendUser',
        component: SuspendUserComponent,
      },
      {
        path: 'suspendMagazine',
        component: SuspendMagazineComponent,
      },
      {
        path: 'deleteProfile',
        component: ProfileRemoveComponent,
      },
      {
        path: 'deleteComment',
        component: CommentDeleteComponent,
      },
      {
        path: 'manageNgWord',
        component: NgWordComponent,
      },
      {
        path: 'followerCount',
        component: FollowerCountComponent,
      },
      {
        path: 'lives',
        component: AdminLiveIndexComponent,
      },
      {
        path: 'lives/create',
        component: LiveCreateComponent,
      },
      {
        path: 'lives/:id/edit',
        component: LiveEditComponent,
      },
      {
        path: 'lives/:id',
        component: AdminLiveIndexDetailComponent,
      },
      {
        path: 'creators',
        component: CreatorIndexComponent,
      },
      {
        path: 'creators/:magazineId/lives',
        component: AdminLiveIndexComponent,
      },
      {
        path: 'creators/:magazineId/lives/:id',
        component: AdminLiveIndexDetailComponent,
      },
      {
        path: 'creators/:magazineId/archives/:id/edit',
        component: ArchiveEditComponent,
      },
      {
        path: 'archives/create',
        component: ArchiveCreateComponent,
      },
      {
        path: 'archives/:id/edit',
        component: ArchiveEditComponent,
      },
      {
        path: 'maintenance',
        component: MaintenanceShowComponent,
      },
      {
        path: 'maintenance/setting',
        component: MaintenanceCreateComponent,
      },
      {
        path: 'config',
        component: ConfigShowComponent,
      },
      {
        path: 'config/setting',
        component: ConfigCreateComponent,
      },
      // 投げ銭リリース後にギフト管理機能を反映
      // {
      //   path: 'gifts',
      //   component: AdminGiftIndexComponent,
      // },
      // {
      //   path: 'gifts/create',
      //   component: AdminGiftCreateComponent,
      // },
      // {
      //   path: 'gifts/:id/edit',
      //   component: AdminGiftEditComponent,
      // },
      {
        path: 'pointPlans',
        component: AdminPointPlanIndexComponent,
      },
      {
        path: 'pointPlans/create',
        component: AdminPointPlanCreateComponent,
      },
      {
        path: 'pointPlans/:id/edit',
        component: AdminPointPlanEditComponent,
      },
      {
        path: 'pointBalance',
        component: AdminPointBalanceIndexComponent,
      },
      {
        path: 'pointHistory',
        component: AdminPointHistoryIndexComponent,
      },
      {
        path: 'orderHistory',
        component: AdminOrderHistoryIndexComponent,
      },
      {
        path: 'salesHistory',
        component: AdminSalesHistoryIndexComponent,
      },
      {
        path: 'transferData',
        component: TransferIndexComponent,
      },
      {
        path: '',
        redirectTo: '/admin/dashboard',
        pathMatch: 'full',
      },
    ],
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: true,
      relativeLinkResolution: 'legacy',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
